import React from "react";
var __jsx = React.createElement;
import { Select, UnstyledButton } from "@mantine/core";
import { format } from "date-fns";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { buildYearOptions } from "./build-year-options";
import { HEADER_SELECT_STYLES, MONTH_CELL_COLORS } from "./date-field-styles";
import { getMonthCellState, resolveMonthBounds, snapMonthRange } from "./month-range";
var MONTHS = Array.from({
  length: 12
}, function (_, index) {
  return {
    key: format(new Date(2000, index, 1), "MMM").toLowerCase(),
    label: format(new Date(2000, index, 1), "MMM")
  };
});

/** Whole-month range selector: a year dropdown over a 12-cell month grid. */
export function MonthGridBody(_ref) {
  var rangeValue = _ref.rangeValue,
    initialYear = _ref.initialYear,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    onSelectRange = _ref.onSelectRange,
    onRequestClose = _ref.onRequestClose,
    testId = _ref.testId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(initialYear),
    displayYear = _useState[0],
    setDisplayYear = _useState[1];
  var _useState2 = useState(null),
    pendingStart = _useState2[0],
    setPendingStart = _useState2[1];
  var _useState3 = useState(null),
    hoveredMonth = _useState3[0],
    setHoveredMonth = _useState3[1];
  var bounds = resolveMonthBounds(pendingStart, hoveredMonth, rangeValue);
  var handleClick = function handleClick(monthIndex) {
    var clicked = new Date(displayYear, monthIndex, 1);
    if (!pendingStart) {
      setPendingStart(clicked);
      onSelectRange(snapMonthRange(clicked, clicked));
      return;
    }
    onSelectRange(snapMonthRange(pendingStart, clicked));
    setPendingStart(null);
    setHoveredMonth(null);
    onRequestClose();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "w-[280px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Select, {
    size: "xs",
    "aria-label": t("year", {
      defaultValue: "Year"
    }),
    data: buildYearOptions(minDate, maxDate),
    value: String(displayYear),
    onChange: function onChange(value) {
      return value && setDisplayYear(Number(value));
    },
    searchable: true,
    withinPortal: true,
    maxDropdownHeight: 240,
    styles: HEADER_SELECT_STYLES,
    "data-testid": "".concat(testId, "-year")
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-3 gap-1.5",
    onMouseLeave: function onMouseLeave() {
      return setHoveredMonth(null);
    }
  }, MONTHS.map(function (_ref2, index) {
    var key = _ref2.key,
      label = _ref2.label;
    var _getMonthCellState = getMonthCellState(displayYear, index, bounds),
      inRange = _getMonthCellState.inRange,
      edge = _getMonthCellState.edge;
    var isHover = !inRange && (hoveredMonth === null || hoveredMonth === void 0 ? void 0 : hoveredMonth.getMonth()) === index && (hoveredMonth === null || hoveredMonth === void 0 ? void 0 : hoveredMonth.getFullYear()) === displayYear;
    return /*#__PURE__*/React.createElement(UnstyledButton, {
      key: key,
      onClick: function onClick() {
        return handleClick(index);
      },
      onMouseEnter: function onMouseEnter() {
        return setHoveredMonth(new Date(displayYear, index, 1));
      },
      className: "rounded-sds-200 py-3 text-center text-style-body-small",
      style: {
        fontWeight: inRange ? 600 : 400,
        color: inRange && edge ? MONTH_CELL_COLORS.edgeText : MONTH_CELL_COLORS.text,
        backgroundColor: inRange ? edge ? MONTH_CELL_COLORS.edgeBg : MONTH_CELL_COLORS.inRangeBg : isHover ? MONTH_CELL_COLORS.hoverBg : "transparent"
      },
      "data-testid": "".concat(testId, "-month-").concat(key)
    }, label);
  })));
}